module.exports = __webpack_public_path__ + "static/img/d2t_pc.8d9fdc07.jpg";